export const selfCostAccounts: number[] = [
  7001, 7002, 7003, 7004, 7005, 7006, 7007, 7008, 7009, 7010, 7014,
];
